import React, { useEffect } from 'react'

type OwnProps = {
  setShowMenu: any
}
type Props = OwnProps

function useOutsideAlerter({ setShowMenu }: Props) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (!(event.target.innerText === 'Ta bort' || event.target.innerText === 'Ändra')) {
        setShowMenu(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default function OutsideAlerter(props) {
  useOutsideAlerter({ setShowMenu: props.setShowMenu })

  return <div>{props.children}</div>
}
